import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
export class FormInfo {
  validators: Validators;
  disabled: boolean;
  constructor(required: boolean, validator: Validators) {
    this.disabled = required;
    this.validators = validator;
  }
}

export function superiorAZero(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!control.value || control.value <= 0) {
      return { superiorAZero: true };
    }
    return null;
  };
}

/**
 * @description
 * Validateurs + required fields des BCForms
 */
export const BCVALIDATORS = {
  CREATE: new Map<string, FormInfo>([

    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['code', new FormInfo(true, [])],
    ['libelle', new FormInfo(false, [Validators.maxLength(80)])],

    ['codeSiteLivraison', new FormInfo(false, [])],
    ['libelleSiteLivraison', new FormInfo(false, [])],

    ['codeSite', new FormInfo(false, [Validators.required])],
    ['libelleSite', new FormInfo(false, [Validators.required])],

    ['codeJProvis', new FormInfo(false, [])],
    ['libelleJProvis', new FormInfo(false, [])],

    ['codeCgProvis', new FormInfo(false, [])],
    ['libelleCgProvis', new FormInfo(false, [])],

    ['codeCa1', new FormInfo(false, [Validators.required])],
    ['libelleCa1', new FormInfo(false, [])],

    ['codeModeRegl', new FormInfo(false, [])],
    ['libelleModeRegl', new FormInfo(false, [])],

    ['codeCondRegl', new FormInfo(false, [])],
    ['libelleCondRegl', new FormInfo(false, [])],

    ['codeFourn', new FormInfo(false, [])],
    ['libelleFourn', new FormInfo(false, [])],

    ['status', new FormInfo(true, [])],
    ['statusNum', new FormInfo(true, [])],
    ['bcAmont', new FormInfo(false, [Validators.maxLength(25)])],
    ['mention', new FormInfo(false, [Validators.maxLength(50)])],
    ['commentaires', new FormInfo(false, [Validators.maxLength(255)])],
    ['refFourn', new FormInfo(false, [Validators.maxLength(30)])],
    ['chantier', new FormInfo(false, [Validators.maxLength(13), Validators.pattern("^[\.0-9]*$")])],

    ['dBc', new FormInfo(false, [])],
    ['dLivraison', new FormInfo(false, [])],
    ['dFinValid', new FormInfo(false,[])],
    ['dRegl', new FormInfo(false, [])],
    ['dAnnule', new FormInfo(true, [])],

    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],

    ['tva', new FormInfo(false, [])],
    ['ht', new FormInfo(false, [])],
    ['ttc', new FormInfo(false, [])],

    ['fValide', new FormInfo(false, [])],
    ['fFacture', new FormInfo(false, [])],
    ['fAnnule', new FormInfo(false, [])],
    ['fProvis', new FormInfo(false, [])],
    ['fDeprovis', new FormInfo(false, [])],
    ['fLivre', new FormInfo(false, [])],
    ['fHasBp', new FormInfo(false, [])],

    ['bRetour', new FormInfo(false, [])],
    ['bBloque', new FormInfo(false, [])],
    ['trigrammeCreateur', new FormInfo(false, [])],
    ['nomCompletCreateur', new FormInfo(false, [])],
    ['fLitige', new FormInfo(false,[])],
    ['type', new FormInfo(true,[])],
  ]),

  BROUILLON: new Map<string, FormInfo>([
    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['code', new FormInfo(true, [])],
    ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(80)])],

    ['codeSiteLivraison', new FormInfo(false, [Validators.required])],
    ['libelleSiteLivraison', new FormInfo(false, [Validators.required])],

    ['codeSite', new FormInfo(true, [Validators.required])],
    ['libelleSite', new FormInfo(true, [Validators.required])],

    ['codeJProvis', new FormInfo(false, [])],
    ['libelleJProvis', new FormInfo(false, [])],

    ['codeCgProvis', new FormInfo(false, [])],
    ['libelleCgProvis', new FormInfo(false, [])],

    ['codeCa1', new FormInfo(false, [Validators.required])],
    ['libelleCa1', new FormInfo(false, [Validators.required])],

    ['codeModeRegl', new FormInfo(false, [Validators.required])],
    ['libelleModeRegl', new FormInfo(false, [Validators.required])],

    ['codeCondRegl', new FormInfo(false, [Validators.required])],
    ['libelleCondRegl', new FormInfo(false, [Validators.required])],

    ['codeFourn', new FormInfo(false, [Validators.required])],
    ['libelleFourn', new FormInfo(false, [Validators.required])],

    ['status', new FormInfo(true, [])],
    ['statusNum', new FormInfo(true, [])],
    ['bcAmont', new FormInfo(false, [Validators.maxLength(25)])],
    ['mention', new FormInfo(false, [Validators.maxLength(50)])],
    ['commentaires', new FormInfo(false, [Validators.maxLength(255)])],
    ['refFourn', new FormInfo(false, [Validators.maxLength(30)])],
    ['chantier', new FormInfo(false, [Validators.maxLength(13), Validators.pattern("^[\.0-9]*$")])],

    ['dBc', new FormInfo(false, [])],
    ['dLivraison', new FormInfo(false, [])],
    ['dFinValid', new FormInfo(false,[])],
    ['dRegl', new FormInfo(false, [])],
    ['dAnnule', new FormInfo(true, [])],

    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],

    ['tva', new FormInfo(false, [])],
    ['ht', new FormInfo(false, [])],
    ['ttc', new FormInfo(false, [])],

    ['fValide', new FormInfo(false, [])],
    ['fFacture', new FormInfo(false, [])],
    ['fAnnule', new FormInfo(false, [])],
    ['fProvis', new FormInfo(false, [])],
    ['fDeprovis', new FormInfo(false, [])],
    ['fLivre', new FormInfo(false, [])],
    ['fHasBp', new FormInfo(false, [])],

    ['bRetour', new FormInfo(false, [])],
    ['bBloque', new FormInfo(false, [])],
    ['trigrammeCreateur', new FormInfo(false, [])],
    ['nomCompletCreateur', new FormInfo(false, [])],
    ['fLitige', new FormInfo(false,[])],
    ['type', new FormInfo(true,[])],
  ]),

  REGULARISE: new Map<string, FormInfo>([
    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['code', new FormInfo(true, [])],
    ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(80)])],

    ['codeSiteLivraison', new FormInfo(false, [Validators.required])],
    ['libelleSiteLivraison', new FormInfo(false, [Validators.required])],

    ['codeSite', new FormInfo(true, [Validators.required])],
    ['libelleSite', new FormInfo(true, [Validators.required])],

    ['codeJProvis', new FormInfo(false, [])],
    ['libelleJProvis', new FormInfo(false, [])],

    ['codeCgProvis', new FormInfo(false, [])],
    ['libelleCgProvis', new FormInfo(false, [])],

    ['codeCa1', new FormInfo(false, [Validators.required])],
    ['libelleCa1', new FormInfo(false, [Validators.required])],

    ['codeModeRegl', new FormInfo(false, [Validators.required])],
    ['libelleModeRegl', new FormInfo(false, [Validators.required])],

    ['codeCondRegl', new FormInfo(false, [Validators.required])],
    ['libelleCondRegl', new FormInfo(false, [Validators.required])],

    ['codeFourn', new FormInfo(false, [Validators.required])],
    ['libelleFourn', new FormInfo(false, [Validators.required])],

    ['status', new FormInfo(true, [])],
    ['statusNum', new FormInfo(true, [])],
    ['bcAmont', new FormInfo(false, [Validators.maxLength(25)])],
    ['mention', new FormInfo(false, [Validators.maxLength(50)])],
    ['commentaires', new FormInfo(false, [Validators.maxLength(255)])],
    ['refFourn', new FormInfo(false, [Validators.maxLength(30)])],
    ['chantier', new FormInfo(false, [Validators.maxLength(13), Validators.pattern("^[\.0-9]*$")])],

    ['dBc', new FormInfo(false, [])],
    ['dLivraison', new FormInfo(false, [])],
    ['dFinValid', new FormInfo(false,[])],
    ['dRegl', new FormInfo(false, [])],
    ['dAnnule', new FormInfo(true, [])],

    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],

    ['tva', new FormInfo(false, [])],
    ['ht', new FormInfo(false, [])],
    ['ttc', new FormInfo(false, [])],

    ['fValide', new FormInfo(false, [])],
    ['fFacture', new FormInfo(false, [])],
    ['fAnnule', new FormInfo(false, [])],
    ['fProvis', new FormInfo(false, [])],
    ['fDeprovis', new FormInfo(false, [])],
    ['fLivre', new FormInfo(false, [])],
    ['fHasBp', new FormInfo(false, [])],

    ['bRetour', new FormInfo(false, [])],
    ['bBloque', new FormInfo(false, [])],
    ['trigrammeCreateur', new FormInfo(false, [])],
    ['nomCompletCreateur', new FormInfo(false, [])],
    ['fLitige', new FormInfo(false,[])],
    ['type', new FormInfo(true,[])],
  ]),

  EDITION: new Map<string, FormInfo>([
    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['code', new FormInfo(true, [])],
    ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(80)])],

    ['codeSiteLivraison', new FormInfo(true, [Validators.required])],
    ['libelleSiteLivraison', new FormInfo(true, [Validators.required])],

    ['codeSite', new FormInfo(true, [Validators.required])],
    ['libelleSite', new FormInfo(true, [Validators.required])],

    ['codeJProvis', new FormInfo(true, [Validators.required])],
    ['libelleJProvis', new FormInfo(true, [Validators.required])],

    ['codeCgProvis', new FormInfo(true, [Validators.required])],
    ['libelleCgProvis', new FormInfo(true, [Validators.required])],

    ['codeCa1', new FormInfo(true, [Validators.required])],
    ['libelleCa1', new FormInfo(true, [Validators.required])],

    ['codeModeRegl', new FormInfo(true, [Validators.required])],
    ['libelleModeRegl', new FormInfo(true, [Validators.required])],

    ['codeCondRegl', new FormInfo(true, [Validators.required])],
    ['libelleCondRegl', new FormInfo(true, [Validators.required])],

    ['codeFourn', new FormInfo(true, [Validators.required])],
    ['libelleFourn', new FormInfo(true, [Validators.required])],

    ['status', new FormInfo(true, [])],
    ['statusNum', new FormInfo(true, [])],
    ['bcAmont', new FormInfo(true, [Validators.maxLength(25)])],
    ['mention', new FormInfo(false, [Validators.maxLength(50)])],
    ['commentaires', new FormInfo(true, [Validators.maxLength(255)])],
    ['refFourn', new FormInfo(false, [Validators.maxLength(30)])],
    ['chantier', new FormInfo(true, [Validators.maxLength(13), Validators.pattern("^[\.0-9]*$")])],

    ['dBc', new FormInfo(true, [])],
    ['dLivraison', new FormInfo(false, [])],
    ['dFinValid', new FormInfo(true,[])],
    ['dRegl', new FormInfo(false, [])],
    ['dAnnule', new FormInfo(true, [])],

    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],

    ['tva', new FormInfo(false, [])],
    ['ht', new FormInfo(false, [])],
    ['ttc', new FormInfo(false, [])],


    ['fValide', new FormInfo(false, [])],
    ['fFacture', new FormInfo(false, [])],
    ['fAnnule', new FormInfo(false, [])],
    ['fProvis', new FormInfo(false, [])],
    ['fDeprovis', new FormInfo(false, [])],
    ['fLivre', new FormInfo(false, [])],
    ['fHasBp', new FormInfo(false, [])],

    ['bRetour', new FormInfo(false, [])],
    ['bBloque', new FormInfo(false, [])],
    ['trigrammeCreateur', new FormInfo(false, [])],
    ['nomCompletCreateur', new FormInfo(false, [])],
    ['fLitige', new FormInfo(false,[])],
    ['type', new FormInfo(true,[])],
  ]),

  VISUALIZE: new Map<string, FormInfo>([
    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['code', new FormInfo(true, [])],
    ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(80)])],

    ['codeSiteLivraison', new FormInfo(true, [Validators.required])],
    ['libelleSiteLivraison', new FormInfo(true, [Validators.required])],

    ['codeSite', new FormInfo(true, [Validators.required])],
    ['libelleSite', new FormInfo(true, [Validators.required])],

    ['codeJProvis', new FormInfo(true, [Validators.required])],
    ['libelleJProvis', new FormInfo(true, [Validators.required])],

    ['codeCgProvis', new FormInfo(true, [Validators.required])],
    ['libelleCgProvis', new FormInfo(true, [Validators.required])],

    ['codeCa1', new FormInfo(true, [Validators.required])],
    ['libelleCa1', new FormInfo(true, [Validators.required])],

    ['codeModeRegl', new FormInfo(true, [Validators.required])],
    ['libelleModeRegl', new FormInfo(true, [Validators.required])],

    ['codeCondRegl', new FormInfo(true, [Validators.required])],
    ['libelleCondRegl', new FormInfo(true, [Validators.required])],

    ['codeFourn', new FormInfo(true, [Validators.required])],
    ['libelleFourn', new FormInfo(true, [Validators.required])],

    ['status', new FormInfo(true, [])],
    ['statusNum', new FormInfo(true, [])],
    ['bcAmont', new FormInfo(true, [])],
    ['mention', new FormInfo(true, [Validators.maxLength(50)])],
    ['commentaires', new FormInfo(true, [Validators.maxLength(255)])],
    ['refFourn', new FormInfo(true, [Validators.maxLength(30)])],
    ['chantier', new FormInfo(true, [Validators.maxLength(13), Validators.pattern("^[\.0-9]*$")])],

    ['dBc', new FormInfo(true, [])],
    ['dLivraison', new FormInfo(true, [])],
    ['dFinValid', new FormInfo(true,[])],
    ['dRegl', new FormInfo(true, [])],
    ['dAnnule', new FormInfo(true, [])],

    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],

    ['tva', new FormInfo(true, [])],
    ['ht', new FormInfo(true, [])],
    ['ttc', new FormInfo(true, [])],

    ['fValide', new FormInfo(true, [])],
    ['fFacture', new FormInfo(true, [])],
    ['fAnnule', new FormInfo(true, [])],
    ['fProvis', new FormInfo(true, [])],
    ['fDeprovis', new FormInfo(true, [])],
    ['fLivre', new FormInfo(true, [])],
    ['fHasBp', new FormInfo(true, [])],

    ['bRetour', new FormInfo(true, [])],
    ['bBloque', new FormInfo(true, [])],
    ['trigrammeCreateur', new FormInfo(true, [])],
    ['nomCompletCreateur', new FormInfo(true, [])],
    ['fLitige', new FormInfo(true,[])],
    ['type', new FormInfo(true,[])],
  ]),

  VALIDATE: new Map<string, FormInfo>([
    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['code', new FormInfo(true, [])],
    ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(80)])],

    ['codeSiteLivraison', new FormInfo(true, [Validators.required])],
    ['libelleSiteLivraison', new FormInfo(true, [Validators.required])],

    ['codeSite', new FormInfo(true, [Validators.required])],
    ['libelleSite', new FormInfo(true, [Validators.required])],

    ['codeJProvis', new FormInfo(true, [Validators.required])],
    ['libelleJProvis', new FormInfo(true, [Validators.required])],

    ['codeCgProvis', new FormInfo(true, [Validators.required])],
    ['libelleCgProvis', new FormInfo(true, [Validators.required])],

    ['codeCa1', new FormInfo(true, [Validators.required])],
    ['libelleCa1', new FormInfo(true, [Validators.required])],

    ['codeModeRegl', new FormInfo(true, [Validators.required])],
    ['libelleModeRegl', new FormInfo(true, [Validators.required])],

    ['codeCondRegl', new FormInfo(true, [Validators.required])],
    ['libelleCondRegl', new FormInfo(true, [Validators.required])],

    ['codeFourn', new FormInfo(true, [Validators.required])],
    ['libelleFourn', new FormInfo(true, [Validators.required])],

    ['status', new FormInfo(true, [])],
    ['statusNum', new FormInfo(true, [])],
    ['bcAmont', new FormInfo(true, [])],
    ['mention', new FormInfo(true, [Validators.maxLength(50)])],
    ['commentaires', new FormInfo(true, [Validators.maxLength(255)])],
    ['refFourn', new FormInfo(true, [Validators.maxLength(30)])],
    ['chantier', new FormInfo(true, [Validators.maxLength(13), Validators.pattern("^[\.0-9]*$")])],

    ['dBc', new FormInfo(true, [])],
    ['dLivraison', new FormInfo(true, [])],
    ['dFinValid', new FormInfo(true,[])],
    ['dRegl', new FormInfo(true, [])],
    ['dAnnule', new FormInfo(true, [])],

    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],

    ['tva', new FormInfo(true, [])],
    ['ht', new FormInfo(true, [])],
    ['ttc', new FormInfo(true, [])],

    ['fValide', new FormInfo(true, [])],
    ['fFacture', new FormInfo(true, [])],
    ['fAnnule', new FormInfo(true, [])],
    ['fProvis', new FormInfo(true, [])],
    ['fDeprovis', new FormInfo(true, [])],
    ['fLivre', new FormInfo(true, [])],
    ['fHasBp', new FormInfo(true, [])],

    ['bRetour', new FormInfo(true, [])],
    ['bBloque', new FormInfo(true, [])],
    ['trigrammeCreateur', new FormInfo(true, [])],
    ['nomCompletCreateur', new FormInfo(true, [])],
    ['fLitige', new FormInfo(true,[])],
    ['type', new FormInfo(true,[])],
  ])
};

/**
 * @description
 * Validateurs + required fields des BCLinesForms
 */
export const BCLINEVALIDATORS = {
  CREATE: new Map<string, FormInfo>([
    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],

    ['code', new FormInfo(false, [])],
    ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(255)])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['idBc', new FormInfo(true, [])],
    // bc: BcModel
    ['codeArticle', new FormInfo(false, [])],
    ['libelleArticle', new FormInfo(false, [])],

    ['codeTva', new FormInfo(false, [Validators.required])],
    ['libelleTva', new FormInfo(false, [Validators.required])],
    ['tauxTva', new FormInfo(false, [Validators.required])],

    ['codeCa1', new FormInfo(false, [Validators.required])],
    ['libelleCa1', new FormInfo(false, [Validators.required])],

    ['codeNa', new FormInfo(true, [Validators.required])],
    ['libelleNa', new FormInfo(true, [Validators.required])],

    ['codeCgCharge', new FormInfo(true, [])],
    ['libelleCgCharge', new FormInfo(true, [])],

    ['codeCa2', new FormInfo(true, [])],
    ['libelleCa2', new FormInfo(true, [])],

    ['chantier', new FormInfo(false, [Validators.maxLength(13), Validators.pattern("^[\.0-9]*$")])],

    ['codeComp', new FormInfo(true, [])],
    ['libelleComp', new FormInfo(true, [])],

    ['destination', new FormInfo(false, [Validators.required])],

    ['codeCategorie', new FormInfo(true, [Validators.required])],
    ['libelleCategorie', new FormInfo(true, [])],

    ['codeFamille', new FormInfo(true, [Validators.required])],
    ['libelleFamille', new FormInfo(true, [Validators.required])],

    ['codeSsFamille', new FormInfo(true, [Validators.required])],
    ['libelleSsFamille', new FormInfo(true, [Validators.required])],

    ['vehicule', new FormInfo(false, [])],

    ['dAnnule', new FormInfo(true, [])],
    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],
    ['dLivraison', new FormInfo(false, [])],

    ['qte', new FormInfo(false, [Validators.required, Validators.min(0.001)])],
    ['qteRestant', new FormInfo(false, [Validators.required, Validators.min(0)])],
    ['qteAnnule', new FormInfo(false, [])],
    ['qteLivre', new FormInfo(false, [Validators.required, Validators.min(0)])],
    ['qteDprovis', new FormInfo(false, [])],
    ['pu', new FormInfo(false, [Validators.required])],
    ['ht', new FormInfo(true, [])],
    ['htRestant', new FormInfo(false, [])],
    ['ttc', new FormInfo(true, [])],
    ['position', new FormInfo(true, [Validators.required])],

    ['fFacture', new FormInfo(false, [])],
    ['fLivre', new FormInfo(false, [])],
    ['fHasbp', new FormInfo(false, [])],

    ['bAnnule', new FormInfo(false, [])],
    ['fProvis', new FormInfo(false, [])],
    ['fDeprovis', new FormInfo(false, [])],
    ['bpLines', new FormInfo(false, [])],
    ['fLitige', new FormInfo(false,[])],
  ]),

  BROUILLON: new Map<string, FormInfo>([
    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],

    ['code', new FormInfo(false, [Validators.required])],
    ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(255)])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['idBc', new FormInfo(true, [])],
    // bc: BcModel
    ['codeArticle', new FormInfo(false, [])],
    ['libelleArticle', new FormInfo(false, [])],

    ['codeTva', new FormInfo(false, [Validators.required])],
    ['libelleTva', new FormInfo(false, [Validators.required])],
    ['tauxTva', new FormInfo(false, [Validators.required])],

    ['codeCa1', new FormInfo(false, [Validators.required])],
    ['libelleCa1', new FormInfo(false, [Validators.required])],

    ['codeNa', new FormInfo(true, [Validators.required])],
    ['libelleNa', new FormInfo(true, [Validators.required])],

    ['codeCgCharge', new FormInfo(true, [])],
    ['libelleCgCharge', new FormInfo(true, [])],

    ['codeCa2', new FormInfo(false, [])],
    ['libelleCa2', new FormInfo(false, [])],

    ['chantier', new FormInfo(false, [Validators.maxLength(13), Validators.pattern("^[\.0-9]*$")])],

    ['codeComp', new FormInfo(false, [])],
    ['libelleComp', new FormInfo(false, [])],

    ['destination', new FormInfo(false, [Validators.required])],

    ['codeCategorie', new FormInfo(false, [Validators.required])],
    ['libelleCategorie', new FormInfo(false, [])],

    ['codeFamille', new FormInfo(false, [Validators.required])],
    ['libelleFamille', new FormInfo(false, [Validators.required])],

    ['codeSsFamille', new FormInfo(false, [Validators.required])],
    ['libelleSsFamille', new FormInfo(false, [Validators.required])],

    ['vehicule', new FormInfo(false, [])],

    ['dAnnule', new FormInfo(true, [])],
    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],
    ['dLivraison', new FormInfo(false, [])],

    ['qte', new FormInfo(false, [Validators.required, Validators.min(0.001)])],
    ['qteRestant', new FormInfo(false, [Validators.required, Validators.min(0)])],
    ['qteAnnule', new FormInfo(false, [])],
    ['qteLivre', new FormInfo(false, [Validators.required, Validators.min(0)])],
    ['qteDprovis', new FormInfo(false, [])],
    ['pu', new FormInfo(false, [Validators.required])],
    ['ht', new FormInfo(true, [])],
    ['htRestant', new FormInfo(false, [])],
    ['ttc', new FormInfo(true, [])],
    ['position', new FormInfo(true, [Validators.required])],

    ['fFacture', new FormInfo(false, [])],
    ['fLivre', new FormInfo(false, [])],
    ['fHasBp', new FormInfo(false, [])],

    ['bAnnule', new FormInfo(false, [])],
    ['fProvis', new FormInfo(false, [])],
    ['fDeprovis', new FormInfo(false, [])],
    ['bpLines', new FormInfo(false, [])],
    ['fLitige', new FormInfo(false,[])],
  ]),

  BROUILLON_ENVELOPPE: new Map<string, FormInfo>([
    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],

    ['code', new FormInfo(false, [Validators.required])],
    ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(255)])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['idBc', new FormInfo(true, [])],
    // bc: BcModel
    ['codeArticle', new FormInfo(false, [])],
    ['libelleArticle', new FormInfo(false, [])],

    ['codeTva', new FormInfo(true, [Validators.required])],
    ['libelleTva', new FormInfo(true, [Validators.required])],
    ['tauxTva', new FormInfo(true, [Validators.required])],

    ['codeCa1', new FormInfo(false, [Validators.required])],
    ['libelleCa1', new FormInfo(false, [Validators.required])],

    ['codeNa', new FormInfo(true, [Validators.required])],
    ['libelleNa', new FormInfo(true, [Validators.required])],

    ['codeCgCharge', new FormInfo(true, [])],
    ['libelleCgCharge', new FormInfo(true, [])],

    ['codeCa2', new FormInfo(false, [])],
    ['libelleCa2', new FormInfo(false, [])],

    ['chantier', new FormInfo(false, [Validators.maxLength(13), Validators.pattern("^[\.0-9]*$")])],

    ['codeComp', new FormInfo(false, [])],
    ['libelleComp', new FormInfo(false, [])],

    ['destination', new FormInfo(false, [Validators.required])],

    ['codeCategorie', new FormInfo(false, [Validators.required])],
    ['libelleCategorie', new FormInfo(false, [])],

    ['codeFamille', new FormInfo(false, [Validators.required])],
    ['libelleFamille', new FormInfo(false, [Validators.required])],

    ['codeSsFamille', new FormInfo(false, [Validators.required])],
    ['libelleSsFamille', new FormInfo(false, [Validators.required])],

    ['vehicule', new FormInfo(false, [])],

    ['dAnnule', new FormInfo(true, [])],
    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],
    ['dLivraison', new FormInfo(true, [])],

    ['qte', new FormInfo(false, [Validators.required, Validators.min(0)])],
    ['qteRestant', new FormInfo(false, [Validators.required, Validators.min(0)])],
    ['qteAnnule', new FormInfo(false, [])],
    ['qteLivre', new FormInfo(false, [Validators.required, Validators.min(0)])],
    ['qteDprovis', new FormInfo(false, [])],
    ['pu', new FormInfo(false, [Validators.required])],
    ['ht', new FormInfo(false, [Validators.required, Validators.min(0.001)])],
    ['htRestant', new FormInfo(false, [])],
    ['ttc', new FormInfo(true, [])],
    ['position', new FormInfo(true, [Validators.required])],

    ['fFacture', new FormInfo(false, [])],
    ['fLivre', new FormInfo(false, [])],
    ['fHasBp', new FormInfo(false, [])],

    ['bAnnule', new FormInfo(false, [])],
    ['fProvis', new FormInfo(false, [])],
    ['fDeprovis', new FormInfo(false, [])],
    ['bpLines', new FormInfo(false, [])],
    ['fLitige', new FormInfo(false,[])],
  ]),

  EDITION: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],

    ['code', new FormInfo(false, [])],
    ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(255)])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['idBc', new FormInfo(true, [])],
    ['codeArticle', new FormInfo(true, [Validators.required])],
    ['libelleArticle', new FormInfo(true, [Validators.required])],

    ['codeTva', new FormInfo(false, [Validators.required])],
    ['libelleTva', new FormInfo(false, [])],
    ['tauxTva', new FormInfo(false, [Validators.required])],

    ['codeCa1', new FormInfo(true, [Validators.required])],
    ['libelleCa1', new FormInfo(true, [Validators.required])],

    ['codeNa', new FormInfo(true, [Validators.required])],
    ['libelleNa', new FormInfo(true, [Validators.required])],

    ['codeCgCharge', new FormInfo(true, [Validators.required])],
    ['libelleCgCharge', new FormInfo(true, [Validators.required])],

    ['codeCa2', new FormInfo(true, [Validators.required])],
    ['libelleCa2', new FormInfo(true, [Validators.required])],

    ['destination', new FormInfo(false, [])],

    ['codeCategorie', new FormInfo(false, [])],
    ['libelleCategorie', new FormInfo(false, [])],

    ['codeFamille', new FormInfo(false, [])],
    ['libelleFamille', new FormInfo(false, [])],

    ['codeSsFamille', new FormInfo(false, [])],
    ['libelleSsFamille', new FormInfo(false, [])],

    ['chantier', new FormInfo(false, [])],

    ['codeComp', new FormInfo(true, [])],
    ['libelleComp', new FormInfo(true, [])],

    ['vehicule', new FormInfo(false, [])],

    ['dAnnule', new FormInfo(true, [])],
    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],
    ['dLivraison', new FormInfo(false, [])],

    ['qte', new FormInfo(true, [Validators.required, Validators.min(0.001)])],
    ['qteRestant', new FormInfo(false, [Validators.required, Validators.min(0)])],
    ['qteAnnule', new FormInfo(false, [])],
    ['qteLivre', new FormInfo(false, [Validators.required, Validators.min(0)])],
    ['qteDprovis', new FormInfo(false, [])],
    ['pu', new FormInfo(false, [Validators.required])],
    ['ht', new FormInfo(true, [])],
    ['htRestant', new FormInfo(false, [])],
    ['ttc', new FormInfo(true, [])],

    ['fFacture', new FormInfo(true, [])],
    ['fLivre', new FormInfo(false, [])],
    ['fHasbp', new FormInfo(true, [])],

    ['bAnnule', new FormInfo(false, [])],
    ['fProvis', new FormInfo(true, [])],
    ['fDeprovis', new FormInfo(true, [])],
    ['bpLines', new FormInfo(false, [])],
    ['fLitige', new FormInfo(false, [])],
  ]),
  

  EDITION_ANNULE: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],

    ['code', new FormInfo(true, [])],
    ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(255)])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['idBc', new FormInfo(true, [])],
    ['codeArticle', new FormInfo(true, [Validators.required])],
    ['libelleArticle', new FormInfo(true, [Validators.required])],

    ['codeTva', new FormInfo(true, [Validators.required])],
    ['libelleTva', new FormInfo(true, [])],
    ['tauxTva', new FormInfo(true, [Validators.required])],

    ['codeCa1', new FormInfo(true, [Validators.required])],
    ['libelleCa1', new FormInfo(true, [Validators.required])],

    ['codeNa', new FormInfo(true, [Validators.required])],
    ['libelleNa', new FormInfo(true, [Validators.required])],

    ['codeCgCharge', new FormInfo(true, [Validators.required])],
    ['libelleCgCharge', new FormInfo(true, [Validators.required])],

    ['codeCa2', new FormInfo(true, [Validators.required])],
    ['libelleCa2', new FormInfo(true, [Validators.required])],

    ['destination', new FormInfo(false, [])],

    ['codeCategorie', new FormInfo(true, [])],
    ['libelleCategorie', new FormInfo(true, [])],

    ['codeFamille', new FormInfo(true, [])],
    ['libelleFamille', new FormInfo(true, [])],

    ['codeSsFamille', new FormInfo(true, [])],
    ['libelleSsFamille', new FormInfo(true, [])],

    ['chantier', new FormInfo(true, [])],

    ['codeComp', new FormInfo(true, [])],
    ['libelleComp', new FormInfo(true, [])],

    ['vehicule', new FormInfo(true, [])],

    ['dAnnule', new FormInfo(true, [])],
    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],
    ['dLivraison', new FormInfo(true, [])],

    ['qte', new FormInfo(true, [Validators.required, Validators.min(0.001)])],
    ['qteRestant', new FormInfo(true, [Validators.required])],
    ['qteAnnule', new FormInfo(false, [])],
    ['qteLivre', new FormInfo(true, [Validators.required])],
    ['qteDprovis', new FormInfo(false, [])],
    ['pu', new FormInfo(true, [Validators.required])],
    ['ht', new FormInfo(true, [])],
    ['htRestant', new FormInfo(true, [])],
    ['ttc', new FormInfo(true, [])],

    ['fFacture', new FormInfo(true, [])],
    ['fLivre', new FormInfo(true, [])],
    ['fHasbp', new FormInfo(true, [])],

    ['bAnnule', new FormInfo(true, [])],
    ['fProvis', new FormInfo(true, [])],
    ['fDeprovis', new FormInfo(true, [])],
    ['bpLines', new FormInfo(false, [])],
    ['fLitige', new FormInfo(true,[])],
  ]),

  VISUALIZE: new Map<string, FormInfo>([
    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],

    ['code', new FormInfo(true, [])],
    ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(255)])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['idBc', new FormInfo(true, [])],
    // bc: BcModel
    ['codeArticle', new FormInfo(true, [Validators.required])],
    ['libelleArticle', new FormInfo(true, [Validators.required])],

    ['codeTva', new FormInfo(true, [Validators.required])],
    ['libelleTva', new FormInfo(true, [])],
    ['tauxTva', new FormInfo(true, [Validators.required])],

    ['codeCa1', new FormInfo(true, [Validators.required])],
    ['libelleCa1', new FormInfo(true, [Validators.required])],

    ['codeNa', new FormInfo(true, [Validators.required])],
    ['libelleNa', new FormInfo(true, [Validators.required])],

    ['codeCgCharge', new FormInfo(true, [Validators.required])],
    ['libelleCgCharge', new FormInfo(true, [Validators.required])],

    ['codeCa2', new FormInfo(true, [Validators.required])],
    ['libelleCa2', new FormInfo(true, [Validators.required])],

    ['destination', new FormInfo(true, [])],

    ['codeCategorie', new FormInfo(true, [])],
    ['libelleCategorie', new FormInfo(true, [])],

    ['codeFamille', new FormInfo(true, [])],
    ['libelleFamille', new FormInfo(true, [])],

    ['codeSsFamille', new FormInfo(true, [])],
    ['libelleSsFamille', new FormInfo(true, [])],

    ['chantier', new FormInfo(true, [])],

    ['codeComp', new FormInfo(true, [])],
    ['libelleComp', new FormInfo(true, [])],

    ['vehicule', new FormInfo(true, [Validators.required])],

    ['dAnnule', new FormInfo(true, [])],
    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],
    ['dLivraison', new FormInfo(true, [])],

    ['qte', new FormInfo(true, [Validators.required, Validators.min(0.001)])],
    ['qteRestant', new FormInfo(true, [Validators.required])],
    ['qteAnnule', new FormInfo(false, [])],
    ['qteLivre', new FormInfo(true, [Validators.required])],
    ['qteDprovis', new FormInfo(false, [])],
    ['pu', new FormInfo(true, [Validators.required])],
    ['ht', new FormInfo(true, [])],
    ['htRestant', new FormInfo(true, [])],
    ['ttc', new FormInfo(true, [])],

    ['fFacture', new FormInfo(true, [])],
    ['fLivre', new FormInfo(true, [])],
    ['fHasbp', new FormInfo(true, [])],

    ['bAnnule', new FormInfo(true, [])],
    ['fProvis', new FormInfo(true, [])],
    ['fDeprovis', new FormInfo(true, [])],
    ['bpLines', new FormInfo(false, [])],
    ['fLitige', new FormInfo(true,[])],
  ]),

  VALIDATE: new Map<string, FormInfo>([
    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],

    ['code', new FormInfo(true, [])],
    ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(255)])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['idBc', new FormInfo(true, [])],
    // bc: BcModel
    ['codeArticle', new FormInfo(true, [Validators.required])],
    ['libelleArticle', new FormInfo(true, [Validators.required])],

    ['codeTva', new FormInfo(true, [Validators.required])],
    ['libelleTva', new FormInfo(true, [])],
    ['tauxTva', new FormInfo(true, [Validators.required])],

    ['codeCa1', new FormInfo(true, [Validators.required])],
    ['libelleCa1', new FormInfo(true, [Validators.required])],

    ['codeNa', new FormInfo(true, [Validators.required])],
    ['libelleNa', new FormInfo(true, [Validators.required])],

    ['codeCgCharge', new FormInfo(true, [Validators.required])],
    ['libelleCgCharge', new FormInfo(true, [Validators.required])],

    ['codeCa2', new FormInfo(true, [Validators.required])],
    ['libelleCa2', new FormInfo(true, [Validators.required])],

    ['destination', new FormInfo(true, [Validators.required])],

    ['codeCategorie', new FormInfo(true, [Validators.required])],
    ['libelleCategorie', new FormInfo(true, [])],

    ['codeFamille', new FormInfo(true, [Validators.required])],
    ['libelleFamille', new FormInfo(true, [Validators.required])],

    ['codeSsFamille', new FormInfo(true, [Validators.required])],
    ['libelleSsFamille', new FormInfo(true, [Validators.required])],

    ['chantier', new FormInfo(true, [])],

    ['codeComp', new FormInfo(true, [])],
    ['libelleComp', new FormInfo(true, [])],

    ['vehicule', new FormInfo(true, [Validators.required])],

    ['dAnnule', new FormInfo(true, [])],
    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],
    ['dLivraison', new FormInfo(true, [])],

    ['qte', new FormInfo(true, [Validators.required, Validators.min(0.001)])],
    ['qteRestant', new FormInfo(true, [Validators.required])],
    ['qteAnnule', new FormInfo(false, [])],
    ['qteLivre', new FormInfo(true, [Validators.required])],
    ['qteDprovis', new FormInfo(false, [])],
    ['pu', new FormInfo(true, [Validators.required])],
    ['ht', new FormInfo(true, [])],
    ['htRestant', new FormInfo(true, [])],
    ['ttc', new FormInfo(true, [])],

    ['fFacture', new FormInfo(true, [])],
    ['fLivre', new FormInfo(true, [])],
    ['fHasbp', new FormInfo(true, [])],

    ['bAnnule', new FormInfo(true, [])],
    ['fProvis', new FormInfo(true, [])],
    ['fDeprovis', new FormInfo(true, [])],
    ['bpLines', new FormInfo(false, [])],
    ['fLitige', new FormInfo(true,[])],
  ]),
  REGULARISE: new Map<string, FormInfo>([
    ['id', new FormInfo(true, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],

    ['code', new FormInfo(false, [Validators.required])],
    ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(255)])],
    ['idSociete', new FormInfo(true, [])],
    ['societe', new FormInfo(true, [])],

    ['idBc', new FormInfo(true, [])],
    // bc: BcModel
    ['codeArticle', new FormInfo(false, [])],
    ['libelleArticle', new FormInfo(false, [])],

    ['codeTva', new FormInfo(false, [Validators.required])],
    ['libelleTva', new FormInfo(false, [Validators.required])],
    ['tauxTva', new FormInfo(false, [Validators.required])],

    ['codeCa1', new FormInfo(false, [Validators.required])],
    ['libelleCa1', new FormInfo(false, [Validators.required])],

    ['codeNa', new FormInfo(true, [Validators.required])],
    ['libelleNa', new FormInfo(true, [Validators.required])],

    ['codeCgCharge', new FormInfo(true, [])],
    ['libelleCgCharge', new FormInfo(true, [])],

    ['codeCa2', new FormInfo(false, [])],
    ['libelleCa2', new FormInfo(false, [])],

    ['chantier', new FormInfo(false, [Validators.maxLength(13), Validators.pattern("^[\.0-9]*$")])],

    ['codeComp', new FormInfo(false, [])],
    ['libelleComp', new FormInfo(false, [])],

    ['destination', new FormInfo(false, [Validators.required])],

    ['codeCategorie', new FormInfo(false, [Validators.required])],
    ['libelleCategorie', new FormInfo(false, [])],

    ['codeFamille', new FormInfo(false, [Validators.required])],
    ['libelleFamille', new FormInfo(false, [Validators.required])],

    ['codeSsFamille', new FormInfo(false, [Validators.required])],
    ['libelleSsFamille', new FormInfo(false, [Validators.required])],

    ['vehicule', new FormInfo(false, [])],

    ['dAnnule', new FormInfo(true, [])],
    ['dProvis', new FormInfo(true, [])],
    ['dDeprovis', new FormInfo(true, [])],
    ['dLivraison', new FormInfo(false, [])],

    ['qte', new FormInfo(false, [Validators.required, Validators.min(0.001)])],
    ['qteRestant', new FormInfo(false, [Validators.required, Validators.min(0)])],
    ['qteAnnule', new FormInfo(false, [])],
    ['qteLivre', new FormInfo(false, [Validators.required, Validators.min(0)])],
    ['qteDprovis', new FormInfo(false, [])],
    ['pu', new FormInfo(false, [Validators.required])],
    ['ht', new FormInfo(true, [])],
    ['htRestant', new FormInfo(false, [])],
    ['ttc', new FormInfo(true, [])],
    ['position', new FormInfo(true, [Validators.required])],

    ['fFacture', new FormInfo(false, [])],
    ['fLivre', new FormInfo(false, [])],
    ['fHasBp', new FormInfo(false, [])],

    ['bAnnule', new FormInfo(false, [])],
    ['fProvis', new FormInfo(false, [])],
    ['fDeprovis', new FormInfo(false, [])],
    ['bpLines', new FormInfo(false, [])],
    ['fLitige', new FormInfo(false,[])],
  ]),      
};
